import { DEFAULT_TITLE, BASE_URL_MOBILE, generateTitle, generateCanonicalLink } from './helper';

/**
 * meta.js 페이지 별 메타태그 관리
 */
export const meta = {
	// default
	default: {
		title: DEFAULT_TITLE,
		titleTemplate: '%s | 기프티쇼 비즈',
		meta: [
			{
				vmid: 'description',
				name: 'description',
				content:
					'기업용 기프티콘 대량발송부터 기업판촉물까지, 기프티쇼 비즈에서 제공하는 모바일쿠폰, 사업자기프티콘, 판촉물제작, 기념품제작을 확인해보세요. 기프티쇼 비즈만이 제공하는 모바일 쿠폰 1위 서비스입니다.',
			},
		],
	},

	/**
	 * 모바일쿠폰
	 * path: 'home'
	 * */
	home: {
		title: '기업 기프티콘, 모바일 쿠폰 발송 서비스 1위',
		link: [generateCanonicalLink('/')],
	},

	// /**
	//  * 비즈Shop
	//  * path: 'bizshop'
	//  * */
	category: category => {
		return {
			title: `${category} | 기업 모바일쿠폰 업계 1위`,
			meta: [
				{
					vmid: 'description',
					name: 'description',
					content: `기프티쇼 비즈에서 제공하는 ${category} 혜택을 확인해보세요! 품질 보증/최저가 판촉물까지 한 번에! kt그룹 판촉서비스를 경험해보세요.`,
				},
			],
		};
	},

	/**
	 * 상품 상세
	 * path: 'ggoods/detail'
	 * */
	productDetail: ({ productName = '', brandName = '', goodsNo = '', categorySeq = '', goodsCode = '' }) => {
		let queryString = `goodsNo=${goodsNo}&goodsCode=${goodsCode}`;

		if (categorySeq && categorySeq !== 'undefined') {
			queryString = `goodsNo=${goodsNo}&categorySeq=${categorySeq}&goodsCode=${goodsCode}`;
		}

		return {
			title: `${productName} - ${brandName}`,
			meta: [
				{
					vmid: 'description',
					name: 'description',
					content: `기프티쇼 비즈에서 제공하는 ${productName}의 혜택을 확인하세요. 최신 제품 정보와 특별 프로모션을 놓치지 마세요!`,
				},
			],
			link: [generateCanonicalLink(`/ggoods/detail?${queryString}`)],
		};
	},
	serviceInfo: {
		title: generateTitle('서비스 소개'),
	},
	apiService: {
		title: generateTitle('API 서비스'),
	},
	specialPrice: {
		title: generateTitle('비즈특가'),
		link: [generateCanonicalLink('/specialprice', BASE_URL_MOBILE)],
	},
	allianceList: {
		title: generateTitle('혜택존'),
	},
	estimateList: {
		title: generateTitle('온라인 견적서'),
	},
	estimateManage: {
		title: generateTitle('온라인 견적서'),
	},
	eventList: {
		title: generateTitle('이벤트'),
		link: [generateCanonicalLink('/eventlist')],
	},
	eventDetail: eventSeq => ({
		title: generateTitle('이벤트'),
		link: [generateCanonicalLink(`/eventview?eventSeq=${eventSeq}`)],
	}),
	serviceGuideList: {
		title: generateTitle('서비스 활용 TIP'),
		link: [generateCanonicalLink('/serviceguidelist')],
	},
	serviceGuideDetail: sgSeq => ({
		title: generateTitle('서비스 활용 TIP'),
		link: [generateCanonicalLink(`/serviceguideview?sgSeq=${sgSeq}`)],
	}),
};
